import React from 'react'
import { withNamespaces } from 'react-i18next'
import styled from 'styled-components'

import unknown_user from '../../images/unknown_user.png'

const StyledManagerCard = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;

  padding: 21px 19px 18px 19px;
  background-color: #fff;
  border-radius: 4px;

  margin-bottom: 20px;

  font-family: 'Open Sans', sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #b0bac9;

  .title {
    letter-spacing: 1.12px;
    text-transform: uppercase;
  }
`

const ManagerInfoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;

  font-size: 14px;

  .image {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    margin-right: 25px;
  }
`

const ManagerInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  word-break: break-word;

  .name {
    color: #2E384D;
    margin-bottom: 4px;
  }

  .email {
    color: #8798AD;
  }
`

const ManagerCard = ({ picture_url, name, phone, email, t }) => {
  return (
    <StyledManagerCard>
      <div className="title">{t('contracts:contact')}</div>
      <ManagerInfoContainer>
        <img
          className="image"
          src={picture_url}
          alt="manager"
          onError={(e) => (e.target.src = unknown_user)}
        />
        <ManagerInfo>
          <div className="name">{name}</div>
          <a href={`mailto:${email}`} className="email">
            {email}
          </a>
        </ManagerInfo>
      </ManagerInfoContainer>
    </StyledManagerCard>
  )
}

export default withNamespaces()(ManagerCard)
